var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "profile-page" },
    [
      _c("h2", [
        _c(
          "a",
          {
            staticStyle: { float: "left" },
            on: {
              click: function ($event) {
                return _vm.goBack()
              },
            },
          },
          [_c("el-icon", { attrs: { name: "back" } })],
          1
        ),
        _vm._v("\n    My Profile\n  "),
      ]),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "profile-row", attrs: { gutter: 50 } },
        [
          _c("el-col", { attrs: { span: 8 } }, [
            _c("div", { staticClass: "profile-label" }, [
              _vm._v("\n        Email\n      "),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 16 } },
            [
              _c("el-input", {
                attrs: {
                  disabled: true,
                  "suffix-icon": "el-icon-message",
                  readonly: "",
                },
                model: {
                  value: _vm.current_user.email,
                  callback: function ($$v) {
                    _vm.$set(_vm.current_user, "email", $$v)
                  },
                  expression: "current_user.email",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "profile-row", attrs: { gutter: 50 } },
        [
          _c("el-col", { attrs: { span: 8 } }, [
            _c("div", { staticClass: "profile-label" }, [
              _vm._v("\n        Full Name\n      "),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 16 } },
            [
              _c("el-input", {
                attrs: {
                  disabled: true,
                  "suffix-icon": "el-icon-document",
                  readonly: "",
                },
                model: {
                  value: _vm.fullName,
                  callback: function ($$v) {
                    _vm.fullName = $$v
                  },
                  expression: "fullName",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "profile-row", attrs: { gutter: 50 } },
        [
          _c("el-col", { attrs: { span: 8 } }, [
            _c("div", { staticClass: "profile-label" }, [
              _vm._v("\n        Role\n      "),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 16 } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "Select Role" },
                  on: { change: _vm.updateUser },
                  model: {
                    value: _vm.current_user.role,
                    callback: function ($$v) {
                      _vm.$set(_vm.current_user, "role", $$v)
                    },
                    expression: "current_user.role",
                  },
                },
                _vm._l(_vm.roleList, function (role) {
                  return _c("el-option", { key: role, attrs: { value: role } })
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.hasNewLeftNavEnabled
        ? _c("TimeZoneAndLanguageSelectorRow")
        : _c(
            "el-row",
            { staticClass: "profile-row", attrs: { gutter: 50 } },
            [
              _c("el-col", { attrs: { span: 8 } }, [
                _c("div", { staticClass: "profile-label" }, [
                  _vm._v("\n        Timezone\n      "),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 16 } },
                [
                  _c("el-input", {
                    attrs: {
                      disabled: true,
                      "suffix-icon": "el-icon-location",
                      readonly: "",
                    },
                    model: {
                      value: _vm.current_user.timezone,
                      callback: function ($$v) {
                        _vm.$set(_vm.current_user, "timezone", $$v)
                      },
                      expression: "current_user.timezone",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }